import $ from "jquery";
window.$ = window.jQuery = $;
import Swiper from 'swiper';
import { Navigation, Pagination, Grid, Autoplay, EffectFade, Thumbs } from 'swiper/modules';
window.Swiper = Swiper;

import lightGallery from 'lightgallery';
import lgZoom from 'lightgallery/plugins/zoom'
import { is } from "immutable";

window.lightGallery = lightGallery;
window.lgZoom = lgZoom;


$(document).ready(function () {

    $('.js__anchor').click(function (e) {
        e.preventDefault();

        const href = $(this).attr('href');
        const targetId = href.split('#')[1];

        if (targetId) {
            if ($(`#${targetId}`).length > 0) {
                $('html, body').animate({
                    scrollTop: $(`#${targetId}`).offset().top - $('.header').outerHeight(),
                }, 1000);
            } else {
                window.location.href = href;
            }
        } else {
            window.location.href = href;
        }
    });

    //Раскрытие подменю
    $('.js_header_nav_button').click(function () {
        let name = $(this).data('submenu')
        let list = $(this).closest('.js_header_nav_list')
        $(list).find('.js_header_nav_button').not($(this)).removeClass('active')
        $('.js_header_nav_list').addClass('scroll_left')
        if ($(this).hasClass('active')) {
            $(this).removeClass('active')
            $('.js_header_submenu').removeClass('active')
            setTimeout(function () {
                $('.js_header_container').removeClass('active')
                $(`.js_header_submenu_item[data-submenu="${name}"]`).removeClass('active')
            }, 300)
        } else {
            $('.js_header_submenu_name_title').text($(this).text())
            $(this).addClass('active')
            if ($('.js_header_submenu_item[data-submenu]').hasClass('active')) {
                $('.js_header_submenu_item[data-submenu]').removeClass('active')
            } else {
                $('.js_header_container').addClass('active')
                $('.js_header_submenu').addClass('active')
            }
            $(`.js_header_submenu_item[data-submenu="${name}"]`).addClass('active')
        }
    });

    $(document).on('click', function (event) {
        const dropdown = $('header');
        if (!dropdown.is(event.target) && dropdown.has(event.target).length === 0) {
            $('.js_header_nav_button').removeClass('active')
            headerClose()
        }
    });

    //Хедер при скролле
    if ($(document).scrollTop() > 0) {
        $('.js_header_container').addClass('scroll')
        $('.js_breadcrumbs_unit_page').addClass('scroll')
    }

    $(document).on('scroll', function () {
        if ($(document).scrollTop() > 0) {
            $('.js_header_container').addClass('scroll')
            $('.js_breadcrumbs_unit_page').addClass('scroll')
        } else {
            $('.js_header_container').removeClass('scroll')
            $('.js_breadcrumbs_unit_page').removeClass('scroll')
        }
    })

    //Открытие меню в адаптиве
    $('.js_header_burger').click(function () {
        $('.js_header_container').addClass('active')
        $('.js_header_nav').addClass('active')
        $('body').addClass('overflow')
    })

    //Адаптивный хедер
    let isResizing = false
    $(window).on('resize', function () {
        isResizing = headerAdapt(isResizing)
    })

    //Адаптивный хедер
    headerAdapt()
})

//Закрытие хедера 
function headerClose() {
    $('.js_header_submenu').removeClass('active')
    $('.js_header_submenu_item').removeClass('active')
    $('.js_header_nav').removeClass('active')
    $('body').removeClass('overflow')
    $('.js_header_nav_list').removeClass('scroll_left')
    $('.js_header_nav_button').removeClass('active')
    setTimeout(function () {
        $('.js_header_container').removeClass('active')
    }, 300)
}

//Адаптивный хедер
function headerAdapt(isResizing) {
    if ($(document).innerWidth() < 1280) {
        if (!isResizing) {
            headerClose()
        }
        $('.js_header_container').removeClass('active')
        if (!$('.js_header_nav_main').find('.js_header_logo, .js_header_dealer').length) {
            $('.js_header_logo').clone().appendTo('.js_header_nav_main')
            $('.js_header_dealer').clone().appendTo('.js_header_nav_main')
            $('.js_header_nav_main .js_header_burger').addClass('active')
            $('.js_header_nav_main .js_header_burger').click(function () {
                headerClose()
            })
            $('.js_header_submenu_name_button').click(function () {
                $('.js_header_nav_list').removeClass('scroll_left')
                $('.js_header_nav_button').removeClass('active')
                $('.js_header_submenu_item').removeClass('active')
                $('.js_header_submenu').removeClass('active')
            })
        }
        return true
    } else {
        $('body').removeClass('overflow')
        $('.js_header_container').removeClass('active')
        $('.js_header_nav').removeClass('active')
        $('.js_header_nav_main').children().remove()
        $('.js_header_nav_list').removeClass('scroll_left')
        $('.js_header_nav_button').removeClass('active')
        $('.js_header_submenu').removeClass('active')
        $('.js_header_submenu_item').removeClass('active')
        return false
    }
}

$(document).ready(function () {
    var circle = `<svg class="circle" width="40px" height="100%" viewBox="0 0 120 120"><circle class="progress-ring" stroke="#cacaca" stroke-width="9" fill="none" r="52" cx="60" cy="60"></circle><circle class="progress-ring__circle" stroke="#1c69d3" stroke-width="9" fill="none" r="52" cx="60" cy="60"></circle></svg>`;
    var pause = `<svg class="pause_icon" width="10px" height="10px" viewBox="0 0 6 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><path d="M0.5,0 L0.5,10 M5.5,0 L5.5,10" stroke="#FFFFFF" stroke-width="3"></path></g></svg>`;
    var play = `<svg class="play_icon" width="10px" height="10px" viewBox="0 0 8 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><path d="M6.08578136,4.98900937 L1.0250437,8.17358388 L1.00554568,1.83685507 L6.08578136,4.98900937 Z" stroke="#FFFFFF" stroke-width="2" fill="#FFFFFF"></path></g></svg>`;

    $('.js__addition_swiper').each(function (index, element) {
        var firstSlide = true;
        var swiper = new Swiper($(element)[0], {
            modules: [Navigation, Pagination, Autoplay, EffectFade],
            slidesPerView: 1,
            spaceBetween: 10,
            effect: 'fade',
            pagination: {
                el: $(element).find('.swiper-pagination')[0],
                clickable: true,
                renderBullet: function (index, className) {
                    if (firstSlide) {
                        firstSlide = false;
                        return '<div class="' + className + '">' + circle + '<p>' + pause + '</p>' + '</div>';
                    }
                    return '<div class="' + className + '">' + circle + '<p>' + (index + 1) + '</p>' + '</div>';
                }
            },
            autoplay: {
                delay: 7000,
                disableOnInteraction: false
            },
            pauseOnMouseEnter: false,
            on: {
                init: function () {
                    if (swiper) {
                        var activeIndex = swiper.activeIndex;
                        updatePaginationText(swiper, activeIndex);
                        animateCircle($(element).find('.swiper-pagination-bullet-active .progress-ring__circle'), 7000);
                    }
                },
                slideChange: function () {
                    if (swiper) {
                        if (!swiper.autoplay.running) {
                            swiper.autoplay.start();
                        }
                        var activeIndex = swiper.activeIndex;
                        updatePaginationText(swiper, activeIndex);
                        animateCircle($(element).find('.swiper-pagination-bullet-active .progress-ring__circle'), 7000);
                    }
                }
            }
        });

        animateCircle($(element).find('.swiper-pagination-bullet-active .progress-ring__circle'), 7000);

        $(element).find('.swiper-pagination').on('click', '.swiper-pagination-bullet-active', function () {
            var progressRingCircle = $(this).find('.progress-ring__circle');

            if (progressRingCircle.is(':animated')) {
                progressRingCircle.stop();
            }

            if (swiper.autoplay.running) {
                animateCircle(progressRingCircle, 7000, 'stop');
                swiper.autoplay.stop();
                $(this).find('p').html(play);
            } else {
                animateCircle(progressRingCircle, 7000, 'play');
                swiper.autoplay.start();
                $(this).find('p').html(pause);
            }
        });
    });

    function updatePaginationText(swiper, activeIndex) {
        swiper.pagination.bullets.forEach(function (bullet, index) {
            var isActive = index === activeIndex;
            var buttonText = isActive ? pause : (index + 1);
            $(bullet).find('p').html(buttonText);
        });
    }

    function animateCircle(circleElement, duration, type = 'start') {
        switch (type) {
            case 'start':
                circleElement.stop();
                circleElement.css('stroke-dashoffset', '326.726');
                circleElement.animate(
                    { 'stroke-dashoffset': 0 },
                    {
                        duration: duration,
                        easing: 'linear'
                    }
                );
                break;

            case 'stop':
                circleElement.stop();
                break;

            case 'play':
                var offset = circleElement.css('stroke-dashoffset');
                circleElement.css('stroke-dashoffset', offset);
                circleElement.animate(
                    { 'stroke-dashoffset': 0 },
                    {
                        duration: duration,
                        easing: 'linear'
                    }
                );
                break;

            default:
                console.error('Unknown animation type:', type);
                break;
        }
    }
});


$(document).ready(function () {
    $('.js__addition_models').each(function (index, element) {
        var swiper = new Swiper($(element)[0], {
            modules: [Navigation, Autoplay],
            slidesPerView: 1.3,
            spaceBetween: 10,
            navigation: {
                nextEl: $(element).find('.swiper-button-next')[0],
                prevEl: $(element).find('.swiper-button-prev')[0],
            },
            breakpoints: {
                1440: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                },
                1280: {
                    slidesPerView: 3.3,
                    spaceBetween: 25,
                },
                992: {
                    slidesPerView: 2.5,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 1.7,
                    spaceBetween: 15,
                }
            },
        });
    });

    $('.js__addition_goods').each(function (index, element) {
        var swiper = new Swiper($(element)[0], {
            modules: [Navigation, Autoplay],
            slidesPerView: 1.3,
            spaceBetween: 10,
            navigation: {
                nextEl: $(element).find('.swiper-button-next')[0],
                prevEl: $(element).find('.swiper-button-prev')[0],
            },
            breakpoints: {
                1440: {
                    slidesPerView: $(element).data('row_count'),
                    spaceBetween: 30,
                },
                1280: {
                    slidesPerView: 3.3,
                    spaceBetween: 25,
                },
                992: {
                    slidesPerView: 2.5,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 1.7,
                    spaceBetween: 15,
                }
            },
        });
    });

    function positionHoveredElement() {
        var activeElement = $('.js__hover_active_element.active');
        if (activeElement.length === 0) {
            return;
        }
        var hoveredElement = $('.js__hover_active_body.active');

        var buttonPosition = activeElement.offset();
        var buttonWidth = activeElement.outerWidth();

        var bodyWidth = hoveredElement.outerWidth();
        var leftPosition = buttonPosition.left + (buttonWidth - bodyWidth) / 2;

        var scrollTop = $(window).scrollTop();

        hoveredElement.css({
            'top': buttonPosition.top - hoveredElement.outerHeight() - scrollTop - 20,
            'left': leftPosition
        });
    }

    function hideModal() {
        $('.js__hover_active_body').hide().removeClass('active');
        $('.js__hover_active_element').removeClass('active');
    }

    if ($(window).outerWidth() > 769) {
        $('.js__hover_active_element').hover(function () {
            hideModal();

            $(this).addClass('active');
            var dataHover = $(this).data('hover');
            var hoveredElement = $('.js__hover_active_body[data-hover-body="' + dataHover + '"]').addClass('active');
            hoveredElement.show();

            positionHoveredElement();
        }, function () {

        });
    } else {
        $('.js__hover_active_element').click(function () {
            if ($(this).hasClass('active')) {
                hideModal();
            } else {
                hideModal();

                $(this).addClass('active');
                var dataHover = $(this).data('hover');
                var hoveredElement = $('.js__hover_active_body[data-hover-body="' + dataHover + '"]').addClass('active');
                hoveredElement.show();

                positionHoveredElement();
            }
        });
    }

    function heightName() {
        $('.js__name_wrapper').each(function () {
            $(this).find('.js__name_height').css('min-height', 0);

            let heightNameTitle = 0;
            $(this).find('.js__name_height').each(function () {
                if ($(this).outerHeight() > heightNameTitle) {
                    heightNameTitle = $(this).outerHeight();
                }
            });

            $(this).find('.js__name_height').css('min-height', heightNameTitle);
        })
    }

    $(document).click(function (event) {
        if (!$(event.target).closest('.js__hover_active_body').length &&
            !$(event.target).closest('.js__hover_active_element').length) {
            hideModal();
        }
    });

    $(window).scroll(function () {
        positionHoveredElement();
    });

    heightName();

    $(window).resize(function () {
        heightName();
    })
});


$(document).ready(function () {
    $('.js__text_last_span').each(function () {
        var paragraphs = $(this).children('p');
        if (paragraphs.length > 0) {
            var lastParagraph = paragraphs.last();
            lastParagraph.replaceWith('<span>' + lastParagraph.html() + '</span>');
        }
    });

    function hideModalGlobal() {
        $('.js__hover_active_body_blobal').hide().removeClass('active');
        $('.js__hover_active_element_global').removeClass('active');
    }


    function positionHoveredElementGlobal() {
        var activeElement = $('.js__hover_active_element_global.active');
        if (activeElement.length === 0) {
            return;
        }
        var hoveredElement = $('.js__hover_active_body_blobal.active');

        var buttonPosition = activeElement.offset();
        var buttonWidth = activeElement.outerWidth();

        var bodyWidth = hoveredElement.outerWidth();
        var leftPosition = buttonPosition.left + (buttonWidth - bodyWidth) / 2;

        var screenWidth = $(window).width();
        var elementRightX = leftPosition + bodyWidth;

        if (leftPosition < 0) {
            leftPosition = 0;
        }

        if (elementRightX > screenWidth) {
            var xOffset = elementRightX - screenWidth;
            leftPosition -= xOffset;
        }

        var scrollTop = $(window).scrollTop();

        hoveredElement.css({
            'top': buttonPosition.top - hoveredElement.outerHeight() - scrollTop - 10,
            'left': leftPosition
        });
    }


    if ($(window).outerWidth() > 769 && $(window).outerWidth() < 1440) {
        $('.js__hover_active_element_global').hover(function () {
            hideModalGlobal();

            $(this).addClass('active');
            var hoveredElement = $(this).closest('.js__hover_active').find('.js__hover_active_body_blobal').addClass('active');
            hoveredElement.show();

            positionHoveredElementGlobal();
        }, function () {

        });
    } else if ($(window).outerWidth() < 769) {
        $('.js__hover_active_element_global').click(function () {
            if ($(this).hasClass('active')) {
                hideModalGlobal();
            } else {
                hideModalGlobal();

                $(this).addClass('active');
                var hoveredElement = $(this).closest('.js__hover_active').find('.js__hover_active_body_blobal').addClass('active');
                hoveredElement.show();

                positionHoveredElementGlobal();
            }
        });
    }

    $(document).click(function (event) {
        if (!$(event.target).closest('.js__hover_active_element_global').length &&
            !$(event.target).closest('.js__hover_active_body_blobal').length) {
            hideModalGlobal();
        }
    });

    $(window).scroll(function () {
        positionHoveredElementGlobal();
    });
});


$(document).ready(function () {

    $('.js__video_start').each(function () {
        var videoStartElement = $(this);

        var videoElement = videoStartElement.find('video')[0];
        var videoSourceElement = videoStartElement.find('video source');

        videoSourceElement.attr('src', videoSourceElement.data('src'));
        videoElement.load();
        videoSourceElement.attr({
            'data-load': true,
            'data-src': ''
        });
    });
});

$(document).ready(function () {
    $('.js__breadcrumbs_btn').click(function () {
        $(this).toggleClass('active')
            .closest('.breadcrumbs_wrapper').toggleClass('active')
            .find('.breadcrumbs').toggleClass('active');
    });

    if ($('.js__good_gallery').length > 0) {

        const items = $('.js__good_gallery .swiper-slide').length;

        var swiper = new Swiper(".js__good_gallery", {
            slidesPerView: 'auto',
            centeredSlides: true,
            initialSlide: items > 4 ? 2 : 1,
            loop: true,
            modules: [Navigation, Pagination],
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            }
        });


        lightGallery(document.getElementById('js__good_zoom'), {
            plugins: [lgZoom],
            speed: 500,
            selector: '.js__zoom_photo',
            licenseKey: 'your_license_key'
        });

    }
});

$(document).ready(function () {
    $('.js__multi_tabs_btn').click(function () {

        if (!$(this).hasClass('active')) {
            $(this).closest('.js__multi_tabs_wrapper')
                .find('.js__multi_tabs_btn, .js__multi_tabs_block').removeClass('active');

            const name = $(this).data('type');

            $(this).addClass('active')
                .closest('.js__multi_tabs_wrapper')
                .find(`.js__multi_tabs_block[data-type=${name}]`).addClass('active')
        }
    });

    $('.js__addition_swiper_bottom').each(function (index, element) {
        var swiper = new Swiper($(element)[0], {
            modules: [Navigation, Pagination],
            slidesPerView: 1,
            spaceBetween: 10,

            navigation: {
                nextEl: $(element).find('.swiper-button-next')[0],
                prevEl: $(element).find('.swiper-button-prev')[0],
            },
            pagination: {
                el: $(element).find('.swiper-pagination')[0],
                clickable: true,
            }
        });
    });

    $('.js__addition_swiper_bottom_wrapper').each(function (index, element) {
        let swiperBottom = new Swiper($(element).find('.js__addition_swiper_bottom')[0], {
            modules: [Navigation, Pagination, Thumbs],
            slidesPerView: 1,
            spaceBetween: 10,
            watchSlidesProgress: true,
            navigation: {
                nextEl: $(element).find('.swiper-button-next')[0],
                prevEl: $(element).find('.swiper-button-prev')[0],
            },
            pagination: {
                el: $(element).find('.swiper-pagination')[0],
                clickable: true,
            }
        });

        let swiperTop = new Swiper($(element).find('.js__addition_swiper_bottom_text')[0], {
            modules: [Thumbs],
            spaceBetween: 10,
            slidesPerView: 1,
            watchSlidesProgress: true,
            thumbs: {
                swiper: swiperBottom,
            },
        });

        swiperTop.on('slideChange', function () {
            var currentIndex = swiperTop.activeIndex;
            swiperBottom.slideTo(currentIndex);
        });

        swiperBottom.on('slideChange', function () {
            var currentIndex = swiperBottom.activeIndex;
            swiperTop.slideTo(currentIndex);
        });
    });

    $('.js_button_faqs').click(function () {
        $(this).toggleClass('active')
        $(this).next('.js_block_faqs').toggle(500, 'linear')
    });

    if ($('.js__height_category').length > 0) {
        alignmentTileCatalog();

        $(window).resize(function () {
            alignmentTileCatalog();
        });
    }

    function alignmentTileCatalog() {
        $('.js__height_category .js__tile_name').css('min-height', ``);

        let row_length = 1;

        if (window.innerWidth > 767) {
            row_length = 2
        }


        $('.js__height_category').each(function () {
            let rows_title = {};
            let counter = 0;

            $(this).find('.js__tile_name').each(function (i) {
                if (rows_title[counter]) {
                    rows_title[counter] = [...rows_title[counter], $(this).outerHeight()];
                } else {
                    rows_title[counter] = [$(this).outerHeight()];
                }

                if ((i + 1) % row_length === 0) {
                    counter++;
                }
            })

            $(this).find('.js__tile_name').each(function (i) {
                const row_number = Math.floor(i / row_length);
                const row_title = rows_title[row_number].sort().reverse();

                $(this).css('min-height', `${row_title[0]}px`);
            })
        });
    }
});

$(document).ready(function () {
    loadMediaVide();

    $(window).resize(function () {
        loadMediaVide(false);
    })
});

function loadMediaVide(start = true) {
    $('.js__start_video_media').each(function () {
        const source = $(this).find('source');
        let defaultSrc = '';

        if (start) {
            defaultSrc = source.attr('src');
            source.attr('data-default', defaultSrc)
        } else {
            defaultSrc = source.data('default');
        }

        const desktopSrc = source.data('desktop');
        const tabletSrc = source.data('tablet');
        const mobileSrc = source.data('mobile');

        if ($(window).outerWidth() > 1279) {
            if (typeof desktopSrc !== 'undefined' && desktopSrc != '') {
                source.attr('src', desktopSrc)
            } else {
                source.attr('src', defaultSrc)
            }
        } else if ($(window).outerWidth() <= 1279 && $(window).outerWidth() > 768) {
            if (typeof tabletSrc !== 'undefined' && tabletSrc != '') {
                source.attr('src', tabletSrc)
            } else {
                source.attr('src', desktopSrc)
            }
        } else {
            if (typeof mobileSrc !== 'undefined' && mobileSrc != '') {
                source.attr('src', mobileSrc)
            } else {
                source.attr('src', desktopSrc)
            }
        }

        $(this)[0].load();
    });
}



require('./form');
require('./animation');